import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { switchMap, catchError } from 'rxjs/operators';
import { Injectable, Injector } from '@angular/core';
import { IdentityService } from '../services/identity.service';
import { RequestHelper } from '../helpers/request.helper';

@Injectable()
export class RequestInterceptor implements HttpInterceptor {
	constructor(private readonly identityService: IdentityService, private readonly injector: Injector) {}

	intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
		/**
		 * if it is a request to Identity Service or not an authorized request - do not modify it
		 */
		if (RequestHelper.isIdentityEndpointRequest(request) || !RequestHelper.isAuthorizedRequest(request)) {
			return next.handle(request);
		}

		/**
		 * if the current user is authenticated - attach the "Authorization" header to the request;
		 * or process the error if it happens
		 */
		return this.identityService.authenticate().pipe(
			catchError((error: unknown) => RequestHelper.onAuthorizationError(error, this.injector)),
			switchMap(accessToken => next.handle(RequestHelper.attachAuthorizationHeader(request, accessToken)))
		);
	}
}
